import React from 'react';
import { connect } from 'react-redux';
import { DBDropDown } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNotePlanHrs extends React.Component {

  renderFields() {
    const { noteId, plno, weeks } = this.props;
    const count = Math.min(Math.max(weeks, 1), 8);
    const fields = [];
    for (let i = 1; i <= count; i++) {
      const fieldName = `PLWPWEEK${i}HRS`;
      fields.push(
        <div key={fieldName} className={styles.week_wrapper}>
          <DBDropDown
            key={fieldName}
            noteId={noteId}
            entity="PTPLAN"
            entityKeyColumn="PLNO"
            entityKeyValue={plno}
            customOptions={this.props.customOptions}
            field={fieldName}
            className={styles.hrs_input}
          />
          <span className={styles.hrsLabel}>hrs </span>
        </div>
      );
    }

    return fields;
  }

  renderWeekLabels() {
    const { weeks } = this.props;
    const count = Math.min(Math.max(weeks, 1), 8);
    const labels = [];

    for (let i = 1; i <= count; i++) {
      labels.push(
        <div key={`week-${i}`} className={styles.weekLabel}>
          Week {i}
        </div>
      );
    }

    return <div className={styles.weekLabelContainer}>{labels}</div>;
  }

  render() {
    return (
      <>
        <div className={styles.row_week}>
          <span className={styles.proj_label}>Projected hours per visit/week:</span>
          {this.renderFields()}
        </div>
        <div className={styles.row}>
          <span className={styles.proj_label} />
          {this.renderWeekLabels()}
        </div>

      </>
    );
  }

}

function mapStateToProps(state) {
  let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
  let noteType = parseInt(noteId.split("_")[0]);
  let pk = parseInt(noteId.split("_")[1]);
  let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
    .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
      || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
  let plan = state.entities.notes.PTPLAN[plno];

  return {
    noteId,
    noteType,
    plno,
    plan,
    weeks: plan.PLPOCDURMAX,
  };
}

const connectedPatientCareCenterNotePlanHrs = connect(mapStateToProps)(PatientCareCenterNotePlanHrs);
export { connectedPatientCareCenterNotePlanHrs as PatientCareCenterNotePlanHrs };

